
export { useRateContext } from "./Rate/context"